export default {
  ERROR_TRANSLATOR: new Map([
    ['invalid_grant', 'auth.error-invalid-grant'],
  ]),
};
